import type * as React from "react";

export type BadgeVariant =
  | "default"
  | "secondary"
  | "accent"
  | "outline"
  | "success"
  | "warning"
  | "error"
  | "info"
  | "upcoming"
  | "active"
  | "completed"
  | "bronze"
  | "silver"
  | "gold"
  | "platinum"
  | "diamond";

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: BadgeVariant;
  dot?: boolean;
  pulse?: boolean;
};

/** Status / category badge — pill-shaped. */
export function Badge({
  variant = "default",
  dot = false,
  pulse = false,
  className = "",
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={["pr-badge", `pr-badge--${variant}`, className].filter(Boolean).join(" ")}
      {...props}
    >
      {pulse ? (
        <span className="pr-badge__pulse" />
      ) : dot ? (
        <span className="pr-badge__dot" />
      ) : null}
      {children}
    </span>
  );
}
